import { getOfflineCheckListFunction } from '@/modules/OfflineFiles/queries/getOfflineCheckList/getOfflineCheckListQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getOfflineCheckListQueryOptions = () => {
  return queryOptions({
    queryKey: ['GetOfflineCheck'],
    queryFn: () => getOfflineCheckListFunction(),
    enabled: true,
  });
};
